import React from "react";

function Contact() {
    // IMPORTANT: You will replace this placeholder URL with your actual Google Maps embed URL
    const mapEmbedUrl =
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3986.976897524738!2d72.50097407564948!3d23.04356417915908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9b54a05b0dbb%3A0xa63d12a6ad600584!2sCresco%20IT%20Systems%20Pvt%20Ltd!5e1!3m2!1sen!2sin!4v1765107452298!5m2!1sen!2sin";

    // Note: I'm keeping the form and contact info, but updating the address placeholder
    const newAddress =
        "Second floor, Eyecon, Behind Sindhubhavan, Bodakdev, Ahmedabad - 380054, Gujarat, India";

    return (
        <div className="container mt-5">
            <h1 className="mb-4">Contact Us</h1>

            {/* Contact Info and Form Row */}
            <div className="row mb-5">
                {/* Left Column for Contact Information (Card) */}
                <div className="col-md-8 offset-md-2">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Our Details</h5>
                            <hr />
                            <p className="card-text">
                                📍 <strong>Address:</strong> {newAddress}
                            </p>
                            <p className="card-text">
                                📞 <strong>Phone:</strong> 7043331311/46
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Map Section - Separated by a horizontal rule for clarity */}
            <hr className="my-5" />
            <h2 className="mb-3">Find Our Location</h2>

            {/* The Responsive Map Embed using Bootstrap's ratio utility */}
            <div className="ratio ratio-16x9">
                <iframe
                    src={mapEmbedUrl}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Our Office Location"
                ></iframe>
            </div>
        </div>
    );
}

export default Contact;
